/* eslint-disable */
import React, {useState} from 'react';
//css
import 'contents/assets/scss/page/accounting.scss';
//component
import PopAmountEdit from '../_PopAmountEdit';
import Calendar from '../../../component/Inc/Calendar';
import Modal from '../../../component/Inc/Modal';

function AccountingCalculateDetail() {
  const [modalAmountEdit, setAmountEdit] = useState(false);
  const [modalAlert, setModalAlert] = useState(0);

  return (
    <main className="com_container">
      <div className="com_center_wrap p_accounting_calculate_detail">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu8_5 active">
            교사 수업 정산 관리
            <span className="bar" />
            <span className="point_txt">김교사320 (수학ㆍ시수 : 45,000)</span>
          </h2>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <Calendar />
            <div className="cont_wrap">
              <section className="cont_item">
                <div className="com_board_list__top">
                  <h2 className="detail_tit dot">학생별 정산 내역</h2>
                  <div className="com_count_wrapper">
                    <div className="operators">
                      <div className="operators_label">
                        <span className="operators_count">총 입금 건수</span>
                        <span className="operators_value">98건</span>
                      </div>
                    </div>
                    <div className="turnover">
                      <div className="turnover_label">
                        <span className="turnover_count">총 입금액</span>
                        <span className="turnover_value">46,500,000</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="com_board_list__scroll">
                  <table className="com_board_list">
                    <colgroup>
                      <col width="50" />
                      <col width="135" />
                      <col width="135" />
                      <col width="135" />
                      <col width="135" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>선택</th>
                        <th>학생명(45)</th>
                        <th>총 진행 수업</th>
                        <th>정산금액</th>
                        <th>정산 상태</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                          <label htmlFor="chk01"></label>
                        </td>
                        <td>김학생103</td>
                        <td>45회</td>
                        <td>45,000</td>
                        <td>정산 대기</td>
                      </tr>
                      {[...Array(8)].map((i, idx) => (
                        <tr key={idx}>
                          <td>
                            <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                            <label htmlFor="chk01"></label>
                          </td>
                          <td>김학생103</td>
                          <td>45회</td>

                          <td>45,000</td>
                          <td>
                            정산완료
                            <br />
                            12,000
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="board_bottom_info">
                  <span className="com_icon red">정산 완료</span>
                  <span className="desc com_red_txt"> 2023, 05, 12 ㅣ 12 : 30 김관리자 </span>
                </div>
                <div className="com_btn_wrap center bottom">
                  <button
                    onClick={() => {
                      setModalAlert(true);
                    }}
                    className="com_btn black xs"
                  >
                    선택항목 정산
                  </button>
                </div>
              </section>
              <section className="cont_item cont_item_2">
                <div className="com_board_list__top">
                  <h2 className="detail_tit dot">학생별 정산 내역 상세보기</h2>
                </div>

                <div className="com_board_list__scroll">
                  <table className="com_board_list">
                    <colgroup>
                      <col width="100" />
                      <col width="100" />
                      <col width="100" />
                      <col width="100" />
                      <col width="100" />
                      <col width="100" />
                      <col width="100" />
                      <col width="100" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>
                          회차
                          <span className="sub">(상품 구성명)</span>
                        </th>
                        <th>지급 구분</th>
                        <th>수업시간</th>
                        <th>메인</th>
                        <th>수업료</th>
                        <th>지목</th>
                        <th>정산금액 전달</th>
                        <th>실 수업료</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[...Array(7)].map((i, idx) => (
                        <tr key={idx}>
                          <td>면접3</td>
                          <td>
                            <button className="btn_link">정액</button>
                          </td>
                          <td>60분</td>
                          <td>메인</td>
                          <td>45,000</td>
                          <td>12,000</td>
                          <td>
                            <button
                              onClick={() => {
                                setAmountEdit(true);
                              }}
                            >
                              홍교사103
                              <br />
                              5,000
                            </button>
                          </td>
                          <td>78,000</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <td className="bg_col"></td>
                      <td className="bg_col"></td>
                      <td className="bg_col"> </td>
                      <td className="bg_col"></td>
                      <td className="bg_col"></td>
                      <td className="bg_col"></td>
                      <td className="bg_col"></td>
                      <td className="bg_col">
                        <strong className="com_blue_txt">78,000</strong>
                      </td>
                    </tfoot>
                  </table>
                </div>
                <div className="com_btn_wrap right">
                  <button className="com_btn black xs btn_down_orange">다운로드</button>
                </div>
                <div className="com_btn_wrap center bottom">
                  <button className="com_btn orange xs">수정</button> <button className="com_btn orange xs">저장</button>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>
      <PopAmountEdit open={modalAmountEdit} close={() => setAmountEdit(false)} />
      <Modal open={modalAlert} close={() => setModalAlert(false)} type="type_alert">
        <div className="content_container">
          <div className="txt padding_bottom_no">선택항목을 정산 하시겠습니까?</div>
        </div>
        <div className="btn_container">
          <button className="com_btn lightGray xs">취소</button>
          <button className="com_btn orange xs">확인</button>
        </div>
      </Modal>
    </main>
  );
}

export default AccountingCalculateDetail;
